import React from "react";
import Skeleton from "../shared/skeleton-component";

const FetchNationalitySkeleton = () => {
  return (
    <>
      <Skeleton width="360px" height="70px" mobWidth="80vw" />
    </>
  );
};

export default FetchNationalitySkeleton;
